export default from './Media';



// WEBPACK FOOTER //
// ./src/containers/Media/index.js